(function(){
    'use strict'

    angular.module('app.unidades')
    .factory('UnidadesService', UnidadesService);

    UnidadesService.$inject = ['$http', '$q', 'apiSettings'];

    function UnidadesService($http, $q, apiSettings) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update:update,
            remove: remove
        };

        return api;

        function getAll(){

            var url = apiSettings.apiBaseUrl + 'api/unidades';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(unidadId){

            var url = apiSettings.apiBaseUrl + 'api/unidades/' + unidadId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(unidad){

            unidad.id = 0;

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/unidades',  
                method: 'POST',  
                data: unidad
            });  
            return response;
        };

        function update(unidad){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/unidades',  
                method: 'PUT',  
                data: unidad
            });  
            return response;
        };

        function remove(unidad){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/unidades',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: unidad
            });  
            return response;
        };

    };

})();